/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/back-icon': {
    width: 29,
    height: 29,
    viewBox: '0 0 29 29',
    data: '<path pid="0" d="M2.995 11.147L17.137 25.29l-2.995 2.994L0 14.142l2.995-2.995z" _fill="#fff"/><path pid="1" d="M0 14.142L14.142 0l2.995 2.995L2.995 17.137 0 14.142z" _fill="#fff"/>'
  }
})
